<template>
  <svg
    :width="computedWidth"
    :height="computedHeight"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="computedColor"
      d="M36.0439 16.2482V10.6112C36.7889 10.263 37.4196 9.71041 37.8627 9.01774C38.3058 8.32506 38.5431 7.52078 38.5468 6.69851V6.56917C38.5468 4.17173 36.6033 2.2282 34.2061 2.2282H34.0765C31.6791 2.2282 29.7356 4.17173 29.7356 6.56917V6.69851C29.7394 7.52078 29.9766 8.32506 30.4197 9.01774C30.8628 9.71041 31.4935 10.263 32.2385 10.6112V16.2482C30.0975 16.5761 28.0811 17.4638 26.3936 18.8216L10.9337 6.7799C11.0439 6.38195 11.1014 5.97273 11.1079 5.56198C11.1098 4.59453 10.8247 3.64826 10.2887 2.84285C9.75275 2.03744 8.98995 1.40909 8.0968 1.03727C7.20366 0.665443 6.22031 0.566857 5.27113 0.75398C4.32195 0.941102 3.44959 1.40552 2.76439 2.0885C2.0792 2.77148 1.61195 3.64233 1.42175 4.5909C1.23155 5.53946 1.32694 6.52313 1.69587 7.41747C2.06479 8.31182 2.69067 9.07665 3.49433 9.61524C4.298 10.1538 5.24334 10.442 6.21079 10.4432C7.05713 10.4392 7.88762 10.2133 8.61932 9.78794L23.8429 21.6342C21.0441 25.8622 21.119 31.3726 24.0315 35.5233L19.4013 40.1549C19.0268 40.0353 18.6371 39.9716 18.2441 39.9663C16.0266 39.9682 14.2302 41.7665 14.2308 43.984C14.2313 46.2013 16.0289 47.9987 18.2462 47.9992C20.4637 47.9998 22.262 46.2034 22.2639 43.9859C22.2587 43.593 22.1951 43.2031 22.0751 42.8289L26.6557 38.2467C30.7485 41.3974 36.3697 41.6689 40.7471 38.9272C45.1244 36.1853 47.3335 31.0091 46.2846 25.9517C45.2358 20.8941 41.1506 17.0235 36.0439 16.2482ZM34.1453 34.788C33.2991 34.8107 32.4569 34.6637 31.6684 34.3556C30.8799 34.0475 30.1612 33.5845 29.5546 32.994C28.948 32.4036 28.4659 31.6975 28.1367 30.9176C27.8074 30.1377 27.6378 29.2998 27.6378 28.4532C27.6378 27.6067 27.8074 26.7687 28.1367 25.9888C28.4659 25.2089 28.948 24.5029 29.5546 23.9124C30.1612 23.3219 30.8799 22.859 31.6684 22.5508C32.4569 22.2427 33.2991 22.0957 34.1453 22.1185C37.5555 22.2379 40.2588 25.0362 40.2607 28.4486C40.2623 31.8607 37.5618 34.6619 34.1516 34.7847"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  width?: number | string;
  height?: number | string;
  size?: number | string; 
  color?: string; // 👈 nuevo prop de color
}>();

const computedWidth = computed(() => props.width ?? props.size ?? 48);
const computedHeight = computed(() => props.height ?? props.size ?? 48);

// color por defecto (el original del SVG)
const computedColor = computed(() => props.color ?? "#FF7A59");
</script>

<style scoped lang="sass"></style>
